import { createSlice } from "@reduxjs/toolkit";
import cookie from "web/script/utils/cookie";

export interface CookieBannerSlice {
    cookieIsAccepted: boolean;
}

const cookieBanner = createSlice({
    name: "cookieBanner",
    initialState: {
        cookieIsAccepted: Boolean(cookie("cookieconsent")),
    } as CookieBannerSlice,
    reducers: {
        changeCookieIsAccepted(state): void {
            state.cookieIsAccepted = true;
        },
    },
});

export const { changeCookieIsAccepted } = cookieBanner.actions;
export default cookieBanner.reducer;
